import type { MenuItem } from '@c/menu'
import { useAuthRoles } from '@/hooks'
import Menu from '@c/menu'

const ManageLayout = () => {
  const roles = useAuthRoles()

  const items: MenuItem[] = useMemo(() => {
    if (!isEmpty(roles.type)) {
      return [
        {
          label: '工作台',
          path: '/manage',
          hidden: ![2, 3].some(role => roles.type?.includes(role)),
        },
        {
          label: ['代理商', '服务'],
          isMain: true,
          hidden: !roles.type?.includes(2),
          children: [
            { label: '销售统计', path: '/manage/sales-stats' },
            { label: '专属推广码', path: '/manage/promos' },
            { label: '受托代签', path: '/products?source=agent' },
            { label: '代签管理', path: '/manage/order' },
            {
              label: '下属契约',
              path: '/manage/branch-order',
              hidden: roles.idInTypeList?.find(t => t.type === 2)?.isHost !== 1,
            }, // 代理商负责人才可查看，总代理商不能查看区域代理商的契约
            {
              label: '成员管理',
              path: '/manage/users-dls',
              hidden: roles.idInTypeList?.find(t => t.type === 2)?.isHost !== 1,
            },
          ],
        },
        {
          label: ['服务商', '服务'],
          isMain: true,
          hidden: !roles.type?.includes(3),
          children: [
            { label: '在线接单', path: '/manage/take-order' },
            { label: '待我执行', path: '/manage/wait-order' },
            {
              label: '执行申请',
              path: '/manage/execute-apply',
              hidden: !roles.idInTypeList?.some(t => t.type === 3),
            },
            {
              label: '执行管理',
              path: '/manage/active-order',
              hidden: roles.idInTypeList?.find(t => t.type === 3)?.isHost !== 1,
            },
            {
              label: '成员管理',
              path: '/manage/users-fws',
              hidden: roles.idInTypeList?.find(t => t.type === 3)?.isHost !== 1,
            },
            {
              label: '结算记录',
              path: '/manage/settle-records',
              hidden: roles.idInTypeList?.find(t => t.type === 3)?.isHost !== 1,
            },
          ],
        },
      ]
    }
    return []
  }, [roles.type])

  return (
    <div className="flex gap-5">
      <Menu className="flex-none" items={items} title="服务后台" />
      <div className="min-w-0 flex-1">
        <Outlet />
      </div>
    </div>
  )
}

export default ManageLayout
